import { render } from "./AppNegocie.vue?vue&type=template&id=6ae8805a&scoped=true"
import script from "./AppNegocie.vue?vue&type=script&lang=js"
export * from "./AppNegocie.vue?vue&type=script&lang=js"

import "./AppNegocie.vue?vue&type=style&index=0&id=6ae8805a&lang=scss&scoped=true"

import exportComponent from "/app/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-6ae8805a"]])

export default __exports__